// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__28pnR","range":"MonthRangeSwitch_range__y6xaH","disabled":"MonthRangeSwitch_disabled__Wj0Hx"};